/**
 * ESocialEventStatusChip Component
 * Colored chip for eSocial event status display
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import {
  ESocialEventStatus,
  ESOCIAL_STATUS_LABELS,
  getEventStatusColor
} from '../../../../types/esocial';

interface ESocialEventStatusChipProps {
  status: ESocialEventStatus;
  size?: ChipProps['size'];
}

const ESocialEventStatusChip: React.FC<ESocialEventStatusChipProps> = ({
  status,
  size = 'small'
}) => {
  return (
    <Chip
      label={ESOCIAL_STATUS_LABELS[status] || status}
      color={getEventStatusColor(status)}
      size={size}
    />
  );
};

export default ESocialEventStatusChip;
